//#region Libraries
import styled from "styled-components";
//#endregion

export const SyncState = styled.span`
    color: var(--light-gray-5);
`;